<div class="main">
  <div class="printing">
    <spb-header></spb-header>
    <router-outlet></router-outlet>
  </div>
  <div [style.flex]="1"></div>

  <div class="printing">
    <spb-footer
      (logoutUser)="configService.reset()"
      [license]="true"
      [token]="configService.accessToken()"
      [version]="version"
      [copyrightYears]="copyrightYears"
    ></spb-footer>
  </div>
</div>